import React from "react";
import { ReactDOM } from "react";
import { useState } from "react";


function Register(){
    
    const [link, setLink] = useState('https://hacktsu2023.devpost.com/');

  const tsuComp = () => {
    window.open(link, '_blank');
  }


    return(
        <div className="   m-5 p-1 w-[100px]  fixed bottom-10 right-2">
        <div className="">
        <button onClick={tsuComp} className="rounded-sm bg-[#86c232] text-[#222629] w-[90px] hover:animate-pulse h-[30px]">
            Submit
        </button>
        </div>

        </div>
    )
}

export default Register;